import { AUTO_SCROLL_DISABLED_LOCAL_STORAGE_KEY } from "../store/client";

/**
 * Extend this function to clean up any local storage keys that are no longer needed. Run this only in logout scenarios.
 *
 * Tip: define the local storage as const in the file where it is used, and import it here to clean it up.
 */
const cleanStorage = () => {
  window.localStorage.removeItem(AUTO_SCROLL_DISABLED_LOCAL_STORAGE_KEY);
};

export default cleanStorage;
